export { default, NoticeIcon, NoticeMark } from './NoticeIcon';
